import formatNumber from "report/common/format-number";

const x = (count: number) => ({
  type: "value",
  max: count,
  interval: Math.ceil(count / 10),
  axisLabel: {
    // show: true,
    fontSize: 10,
    color: "#333",
    formatter: formatNumber
  },
  axisLine: {
    show: true,
    lineStyle: {
      color: "#D9E7F7",
      width: 1
    }
  }
});

export default x;
